import { useSelector } from 'react-redux';
import FJCreationEditStatusBox from '../view/FJCreationEditStatusBox';
import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import FJBlankInVideoPanel from '../../FJBlankPanel/FJBlankInVideoPanel';
import { useDispatch } from 'react-redux';
import FJActionBrushEditCommon from '../../../../redux/action/FJActionBrushEditCommon';
import FJConfig from '../../../../config/FJConfig';
import FJAppConstant from '../../../../constants/FJAppConstant';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJCreationEditLoadBoxContainer = memo(function FJCreationEditLoadBoxContainer(props) {
    useLocalStore();
    const dispatch = useDispatch();

    const { isShow, className, initImagePadding, offsetTop, editImageLoadedStatus, onRefresh } = props;
    const editImage = useSelector(state => state.brushEditCommon.editImage);
    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const useTaskStatus =
        FJConfig.appType === FJAppConstant.OBJECT_ERASER ||
        FJConfig.appType === FJAppConstant.PHOTO_RESTORATION ||
        FJConfig.appType === FJAppConstant.PHOTO_COLORIZE
            ? taskStatus
            : brushEditStatus;

    const onRetry = useCallback(() => {
        dispatch(FJActionBrushEditCommon.retryAction());
    }, [dispatch]);

    if (!editImage) {
        if (FJConfig.appType === FJAppConstant.PHOTO_RESTORATION || FJConfig.appType === FJAppConstant.PHOTO_COLORIZE) {
            const boxDesc =
                FJConfig.appType === FJAppConstant.PHOTO_RESTORATION
                    ? 'ai-old-photos-desc'
                    : 'colorize-black-white-photos-desc';
            const boxTitle =
                FJConfig.appType === FJAppConstant.PHOTO_RESTORATION
                    ? 'ai-old-photos-title'
                    : 'colorize-black-white-photos-title';
            return <FJBlankInVideoPanel active={isShow} boxDesc={boxDesc} boxTitle={boxTitle} />;
        }

        return <FJBlankInVideoPanel active={isShow} />;
    }

    return (
        <FJCreationEditStatusBox
            width={editImage?.width}
            height={editImage?.height}
            isShow={isShow}
            className={className}
            taskStatus={useTaskStatus}
            onRetry={onRetry}
            initImagePadding={initImagePadding}
            offsetTop={offsetTop}
            editImageLoadedStatus={editImageLoadedStatus}
            onRefresh={onRefresh}
        />
    );
});

FJCreationEditLoadBoxContainer.propTypes = {
    isShow: PropTypes.bool,
    className: PropTypes.string,
    initImagePadding: PropTypes.object,
    offsetTop: PropTypes.number,
    editImageLoadedStatus: PropTypes.string,
    onRefresh: PropTypes.func,
};

export default FJCreationEditLoadBoxContainer;
